import { useState, useEffect } from 'react';
import './NotificationsPage.css';
import NotificationsTopBar from './Components/TopBar/TopBar';
import NotificationsTable from './Components/NotificationsTable/NotificationsTable.js';
import NotificationsService from '../AppSettings/services/NotificationService';

const columns: Record<string, keyof Notification> = {
  Subject: 'subject',
  Description: 'description',
};

interface Notification {
  subject: string;
  description: string;
  [key: string]: any;
}

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]); // Store all notifications
  const [filteredNotifications, setFilteredNotifications] = useState<Notification[]>([]); // Store filtered notifications
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(7); // Items per page (same default as MattersPage)
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [pageLimit, setPageLimit] = useState<number>(1);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setLoading(true);
        const response = await NotificationsService.getNotifications();
        setNotifications(response); // Set original data
        setFilteredNotifications(response); // Set filtered data initially to all notifications
      } catch (err) {
        console.log(err);
        setError('An error occurred while fetching notifications.');
      } finally {
        setLoading(false);
      }
    };
    fetchNotifications();
  }, []);

  // Update page limit when filtered notifications or page size changes
  useEffect(() => {
    setPageLimit(Math.max(1, Math.ceil(filteredNotifications.length / pageSize)));
  }, [filteredNotifications, pageSize]);

  const handleSearch = (search: string, filter?: string | null) => {
    if (!filter) {
      return;
    }

    const filtered = notifications.filter((entry) =>
      entry[columns[filter]].toLowerCase().includes(search.toLowerCase())
    );
    setFilteredNotifications(filtered);
    setPage(1); // Reset to page 1 after search
  };

  const handlePagination = (page: number) => {
    setPage(page);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(1); // Reset to first page when changing page size
  };

  return (
    <div className="NotificationsPage">
      <NotificationsTopBar onSearch={handleSearch}></NotificationsTopBar>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>{error}</p>
      ) : (
        <NotificationsTable
          data={filteredNotifications.slice((page - 1) * pageSize, page * pageSize)}
          onNotificationDeleted={() => {}}
          pagination={{
            currPage: page,
            onPageChange: handlePagination,
            pageLimit: pageLimit,
            pageSize: pageSize,
            onPageSizeChange: handlePageSizeChange,
            totalItems: filteredNotifications.length,
            itemLabel: 'notifications',
          }}
        ></NotificationsTable>
      )}
    </div>
  );
};

export default NotificationsPage;